// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3lhI0","rootCenter":"LoadMoreObserver_rootCenter__zwfN_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1fIsJ"};